// src/config/brand.ts
import { ENV } from '@/config/env';

export const BRAND_CONFIG = {
  // Company Information (can be overridden by environment variables)
  name: ENV.BRAND_NAME,
  tagline: ENV.BRAND_TAGLINE,
  description: 'Connect with skilled service providers for all your needs',
  
  // Contact Information
  email: ENV.BRAND_EMAIL,
  phone: '+353 1 234 5678',
  website: ENV.APP_URL,
  
  // Social Media
  social: {
    twitter: '@rapidfix_ie',
    facebook: 'rapidfix.ie',
    linkedin: 'company/rapidfix',
    instagram: '@rapidfix_ie'
  },
  
  // Legal Information
  legal: {
    companyName: 'RapidFix Ireland Ltd.',
    registrationNumber: 'IE123456789',
    vatNumber: 'IE1234567T',
    address: {
      street: '123 Business Street',
      city: 'Dublin',
      county: 'Dublin',
      postcode: 'D02 X123',
      country: 'Ireland'
    }
  },
  
  // App Configuration
  app: {
    version: '1.0.0',
    copyright: `© ${new Date().getFullYear()} ${import.meta.env.VITE_BRAND_NAME || 'RapidFix'} Ireland Ltd. All rights reserved.`,
    privacyPolicyUrl: '/privacy',
    termsOfServiceUrl: '/terms',
    cookiePolicyUrl: '/cookies'
  }
} as const;

// Helper functions for easy access
export const getBrandName = () => BRAND_CONFIG.name;
export const getBrandEmail = () => BRAND_CONFIG.email;
export const getBrandTagline = () => BRAND_CONFIG.tagline;
export const getCopyright = () => BRAND_CONFIG.app.copyright;
export const getCompanyAddress = () => BRAND_CONFIG.legal.address;